var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-callout',{staticClass:"mt-2",attrs:{"has-toggle":false,"border-color":"gray","class-main":_vm.isMobile ? 'p-2' : 'pb-3'}},[_c('div',{staticClass:"row custom-row"},[_c('div',{staticClass:"col-12 col-xl my-2 my-xl-0"},[_c('div',{class:{
          'divider-horizontal': !_vm.isMobile,
          'divider-vertical': _vm.isMobile,
        }},[_c('span',[_vm._v("Tipo de Escuela:")]),_c('div',{staticClass:"regular text-black",class:{
            'text-title': !_vm.isMobile,
            'text-title-mobile': _vm.isMobile,
          }},[_vm._v(" "+_vm._s(_vm.item.type)+" ")])])]),_c('div',{staticClass:"col-12 col-xl-1 my-2 my-xl-0"},[_c('span',[_vm._v("Número de Medicaid:")]),_c('div',{staticClass:"regular text-black",class:{
          'text-title': !_vm.isMobile,
          'text-title-mobile': _vm.isMobile,
        }},[_vm._v(" "+_vm._s(_vm._f("empty")(_vm.item.nationalIdentifier))+" ")])]),_c('div',{staticClass:"col-12 col-xl-3 my-2 my-xl-0"},[_c('span',{class:{
          'text-title': !_vm.isMobile,
          'text-title-mobile': _vm.isMobile,
        }},[_vm._v(" Nombre de Escuela: ")]),_c('div',{staticClass:"regular text-black",class:{
          'text-title': !_vm.isMobile,
          'text-title-mobile': _vm.isMobile,
        }},[_c('strong',[_vm._v(_vm._s(_vm.item.code))]),_vm._v(" - "+_vm._s(_vm.item.name)+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.item.address),expression:"item.address"}],staticClass:"mt-2"},[_c('div',{staticClass:"regular",class:{
            'text-title': !_vm.isMobile,
            'text-title-mobile': _vm.isMobile,
            'mt-3': _vm.isMobile,
          }},[_c('span',{staticClass:"fa-stack force-orange"},[_c('i',{class:[
                'far',
                'fa-map-marker-alt',
                {
                  'fa-stack-1x': !_vm.isMobile,
                  'fa-stack-mobile': _vm.isMobile,
                },
              ]})]),_vm._v(" "+_vm._s(_vm.item.address)+" ")])])]),_c('div',{staticClass:"col-12 col-xl my-2 my-xl-0"},[_c('span',[_vm._v("Creado:")]),_c('div',{staticClass:"regular text-black",class:{
          'text-title': !_vm.isMobile,
          'text-title-mobile': _vm.isMobile,
        }},[_vm._v(" "+_vm._s(_vm.item.createdByFullName)+" ")]),_c('div',{staticClass:"regular text-black",class:{
          'text-title': !_vm.isMobile,
          'text-title-mobile': _vm.isMobile,
        }},[_vm._v(" "+_vm._s(_vm.formatDate(_vm.item.createdDate))+" ")])]),_c('div',{staticClass:"col-12 col-xl my-2 my-xl-0"},[_c('span',[_vm._v("Modificado:")]),_c('div',{staticClass:"regular text-black",class:{
          'text-title': !_vm.isMobile,
          'text-title-mobile': _vm.isMobile,
        }},[_vm._v(" "+_vm._s(_vm.item.modifyByFullName)+" ")]),_c('div',{staticClass:"regular text-black",class:{
          'text-title': !_vm.isMobile,
          'text-title-mobile': _vm.isMobile,
        }},[_vm._v(" "+_vm._s(_vm.formatDate(_vm.item.modifydDate))+" ")])]),_c('div',{staticClass:"col-12 col-xl d-flex align-items-center justify-content-center justify-content-xl-start my-2 my-xl-0"},[([true, false].includes(_vm.item.lastCertified))?_c('badge',{attrs:{"value":_vm.item.lastCertified,"text":"Certificada"}}):_vm._e()],1),_c('div',{staticClass:"col-12 col-xl-1 d-flex align-items-center justify-content-center justify-content-xl-start my-2 my-xl-0"},[_c('span',[_c('span',{class:[
            'badge badges',
            _vm.getBadgeClass(_vm.item.statusDescription),
            {
              'text-title': _vm.isMobile,
              'mt-3': _vm.isMobile,
            },
          ]},[_vm._v(" "+_vm._s(_vm.item.statusDescription)+" ")])])]),_c('div',{staticClass:"col-12 col-xl-auto d-flex align-items-center justify-content-center justify-content-xl-end my-2 my-xl-0"},[_c('ActionButton',{class:{
          'btn-full mt-3': _vm.isMobile,
        },attrs:{"i":"fas fa-file-import pr-1","variant":"outline-success btn-transparent"},on:{"click":function($event){return _vm.editSchool(_vm.item.id)}}},[_vm._v(" Entrar ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }